<template>
  <!-- 导览 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <!-- <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList" class="com-search-box" inline :model="form" ref="form" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="关键词：">
              <el-input v-model="form.fileName" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div>
    </div> -->

    <!-- 列表内容 -->
    <div class="com-list-content" style="padding-top: 0;margin-top: 0;">
      <!-- 表格 -->
      <div class="table">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="userName" label="用户名" show-overflow-tooltip></el-table-column>
          <el-table-column prop="classMethod" label="类名"></el-table-column>
          <el-table-column prop="ip" label="ip地址" show-overflow-tooltip></el-table-column>
          <el-table-column prop="result" label="请求结果" show-overflow-tooltip></el-table-column>
          <el-table-column prop="url" label="请求地址"></el-table-column>
          <!-- <el-table-column  prop="name" label="上传者" show-overflow-tooltip></el-table-column> -->
          <el-table-column label="操作时间" width="140">
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.time, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      form: {
      },
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.$http
        .get('/log/list', {
          ...this.form,
          ...this.listQuery,
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            if (res.result) {
              this.tableData = res.result.records
              this.total = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },


    // 重置查询
    resetForm() {
      this.form = {
        name: '',
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

  },
  created() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.upload-wrapper {
  color: $primary;
}
</style>